import { render, staticRenderFns } from "./TabPlanoSaude.vue?vue&type=template&id=ca52afd0"
import script from "./TabPlanoSaude.vue?vue&type=script&lang=js"
export * from "./TabPlanoSaude.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports